<nav class="app-footer">
  @for (item of navItems(); track item.route) {
    <a
      [routerLink]="item.route"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
      class="footer-item"
    >
      <svg class="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path [attr.d]="item.icon"/>
      </svg>
      <span class="footer-label">{{ item.label }}</span>
    </a>
  }
</nav>
